var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSelectIcon = function SvgSelectIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "81px",
    viewBox: "0 0 80 81",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1180,
    height: 1146,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.5%",
    width: "101.1%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1180,
    height: 1146,
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 370,
    height: 329,
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0625,44.028103 L56.0625,64.0749415 L36,64.0749415 L36,44.028103 L56.0625,44.028103 Z M51.9375,0 L60,0 L60,8.05620609 L63.9375,8.05620609 C66.1875113,8.05620609 68.0937422,8.83683841 69.65625,10.3981265 C71.2187578,11.9594145 72,13.8641574 72,16.1124122 L72,71.9437939 C72,74.1920487 71.2187578,76.0967916 69.65625,77.6580796 C68.0937422,79.2193677 66.1875113,80 63.9375,80 L8.0625,80 C5.81248875,80 3.90625781,79.2193677 2.34375,77.6580796 C0.781242187,76.0967916 0,74.1920487 0,71.9437939 L0,16.1124122 C0,13.8641574 0.781242187,11.9594145 2.34375,10.3981265 C3.90625781,8.83683841 5.81248875,8.05620609 8.0625,8.05620609 L12,8.05620609 L12,0 L20.0625,0 L20.0625,8.05620609 L51.9375,8.05620609 L51.9375,0 Z M63.9375,71.9437939 L63.9375,28.1030445 L8.0625,28.1030445 L8.0625,71.9437939 L63.9375,71.9437939 Z",
    id: "path-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02-Admin-/-Telehealth",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.9-Doctor-Management-/-Enable---Teleconsult",
    transform: "translate(-680.000000, -98.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F6F7FA",
    x: 0,
    y: 0,
    width: 1440,
    height: 1288
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(240.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "black",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component/Layout/Content/Title/General",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF17-Background",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u25A0-Shape",
    x: 0,
    y: 0,
    width: 1180,
    height: 60
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\u270F\\uFE0F-Content",
    fontFamily: "SourceSansPro-Semibold, Source Sans Pro",
    fontSize: 18,
    fontWeight: 500,
    "line-spacing": 27,
    fill: "#192637"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 34
  }, "Doctor Management")))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.4,
    fill: "#000000",
    x: 0,
    y: 1.13686838e-13,
    width: 1440,
    height: 1289
  }), /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(535.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Item-/-Icon-/-40",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_calendar",
    stroke: "none",
    fill: "none",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, 0.000000)",
    fill: "#62CAA4",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelectIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/select-icon.6b467a66.svg";
export { ForwardRef as ReactComponent };